<template>
  <div style="text-align: center; padding-top: 40px; color: #a2a2a2">
    请使用手机端打开~
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {});
    return { state };
  },
};
</script>
<style scoped></style>
